import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ItemOpinion from './ItemOpinion';
import useIsClient from '../../hooks/useIsClient';
import { Opinion } from '../../models/Opinion';
import styles from './styles.module.scss';

type SwiperBreakpoints = Record<number, {
    slidesPerView?: number
    slidesPerGroup?: number
    spaceBetween?: number
}>

type CarouselDeOpinionesV2Props = {
    data: Opinion[]
    autoplay?: any
    spaceBetween?: number
    slidesPerView?: number
    slidesPerGroup?: number
    loop?: boolean
    navigation?: boolean
    pagination?: any
    scrollbar?: any
    // Config de Swiper por ancho mínimo de viewport (mobile-first), reemplaza
    // el viejo patrón de "prop distinta según useMobileHook".
    breakpoints?: SwiperBreakpoints
}

const CarouselDeOpinionesV2 = ({
  data,
  autoplay,
  spaceBetween,
  slidesPerView,
  slidesPerGroup,
  loop,
  navigation,
  pagination,
  scrollbar,
  breakpoints,
}: CarouselDeOpinionesV2Props) => {

  const opiniones = data || [];

  // loop + breakpoints resuelve el breakpoint en cliente antes de que
  // termine la hidratación → mismatch. Se difiere el montaje al cliente
  // cuando hay breakpoints.
  const isClient = useIsClient();
  if (breakpoints && !isClient) return null;

  return (
    <Swiper
      className={styles.swiper}
      modules={[Navigation, Pagination, Scrollbar, Autoplay]}
      autoplay={autoplay}
      spaceBetween={spaceBetween}
      slidesPerView={slidesPerView}
      slidesPerGroup={slidesPerGroup}
      loop={loop}
      navigation={navigation}
      scrollbar={scrollbar}
      pagination={pagination}
      breakpoints={breakpoints}
    >
      {opiniones.map((item, i) => (
        <SwiperSlide key={item.id ?? i} className={styles.slide}>
          <ItemOpinion item={item} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default CarouselDeOpinionesV2;
